import { render, staticRenderFns } from "./BiblesIndex.vue?vue&type=template&id=6fbcf4dc&scoped=true&"
import script from "./BiblesIndex.vue?vue&type=script&lang=js&"
export * from "./BiblesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbcf4dc",
  null
  
)

export default component.exports